import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import './App.css';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./components/home/home";
import SignIn from "./components/signin/signin";
import SignUp from "./components/signup/signup";

function App() {
  return (
    <div className="App">
      <Router>
        <Home />
        <Route path={'/sign-in'}><SignIn /></Route>
        <Route path={'/sign-up'}><SignUp /></Route>
      </Router>
    </div >
  );
}

export default App;
